<script setup>
import ResponsiveLayout from './layouts/ResponsiveLayout.vue'
import { useHead } from '@vueuse/head'

// 设置全局SEO meta信息
useHead({
  title: '专线直达物流服务 - 四川成都、江西南康、广东佛山至重庆各区县',
  meta: [
    {
      name: 'description',
      content: '专业专线直达物流服务，覆盖四川成都、江西南康、广东佛山到重庆江津、綦江、璧山、永川、大足、荣昌、合川、南川、万盛等区县。提供高效、安全、准时的货物运输服务。'
    },
    {
      name: 'keywords',
      content: '专线直达,物流运输,成都到重庆,南康到重庆,佛山到重庆,江津物流,綦江货运,璧山专线,永川配送,大足运输,荣昌快递,合川物流,南川货运,万盛配送'
    },
    {
      name: 'author',
      content: '专线直达物流有限公司'
    },
    {
      property: 'og:title',
      content: '专线直达物流服务 - 覆盖川渝地区主要城市'
    },
    {
      property: 'og:description',
      content: '专业专线直达物流服务，连接四川、江西、广东与重庆各区县，提供高效可靠的货物运输解决方案。'
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:image',
      content: '/images/logistics-og-image.jpg'
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image'
    },
    {
      name: 'twitter:title',
      content: '专线直达物流服务'
    },
    {
      name: 'twitter:description',
      content: '专业专线直达物流，覆盖川渝地区主要城市'
    },
    {
      name: 'robots',
      content: 'index, follow'
    },
    {
      name: 'googlebot',
      content: 'index, follow'
    }
  ],
  link: [
    {
      rel: 'canonical',
      href: 'https://www.yourdomain.com/'
    },
    {
      rel: 'alternate',
      hreflang: 'zh-CN',
      href: 'https://www.yourdomain.com/'
    }
  ]
})
</script>

<template>
  <ResponsiveLayout />
</template>

<style>
/* 全局居中布局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  width: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f5f7fa;
  overflow-y: auto;
}

#app {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  overflow: visible;
}

a {
  text-decoration: none;
  color: inherit;
}

ul, ol {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

/* 居中容器 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 网格系统 */
.grid {
  display: grid;
  gap: 2rem;
}

.grid-cols-1 { grid-template-columns: 1fr; }
.grid-cols-2 { grid-template-columns: repeat(2, 1fr); }
.grid-cols-3 { grid-template-columns: repeat(3, 1fr); }
.grid-cols-4 { grid-template-columns: repeat(4, 1fr); }

/* 按钮样式 */
.btn {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.btn-primary {
  background-color: #3498db;
  color: white;
}

.btn-primary:hover {
  background-color: #2980b9;
  transform: translateY(-2px);
}

/* 卡片样式 */
.card {
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

/* 响应式媒体查询 */
@media (max-width: 1200px) {
  .grid-cols-4 { grid-template-columns: repeat(3, 1fr); }
  
  #app {
    max-width: 95%;
    margin: 0 auto;
  }
}

@media (max-width: 992px) {
  .grid-cols-3,
  .grid-cols-4 { grid-template-columns: repeat(2, 1fr); }
  
  .container {
    padding: 0 1.5rem;
  }
  
  #app {
    max-width: 98%;
  }
}

@media (max-width: 768px) {
  html {
    font-size: 14px;
  }
  
  .grid-cols-2,
  .grid-cols-3,
  .grid-cols-4 { grid-template-columns: 1fr; }
  
  .container {
    padding: 0 1rem;
  }
  
  .card:hover {
    transform: none;
  }
  
  #app {
    max-width: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}

@media (max-width: 480px) {
  html {
    font-size: 13px;
  }
  
  .btn {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
  }
  
  .container {
    padding: 0 0.75rem;
  }
}
</style>